/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { listCountriesGetResponseSchema } from './listCountriesGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getListCountries200Schema = z.lazy(() => listCountriesGetResponseSchema);

/**
 * @description 505 response
 */
export const getListCountries505Schema = z.any();

export const getListCountriesQueryResponseSchema = z.lazy(() => getListCountries200Schema);
